export interface BarItem {
  label: string;
  value: number;
  color: string;
}

interface BarListProps {
  items: BarItem[];
}

export default function BarList({ items }: BarListProps) {
  const max = Math.max(1, ...items.map((i) => i.value));

  return (
    <div className="space-y-2.5 sm:space-y-3.5">
      {items.map((item) => {
        const width = Math.round((item.value / max) * 100);
        return (
          <div key={item.label}>
            <div className="flex items-center justify-between text-xs sm:text-sm mb-1 sm:mb-1.5 gap-2">
              <span className="text-foreground-600 truncate">{item.label}</span>
              <span className="text-foreground-900 font-semibold shrink-0" dir="ltr">
                {item.value}
              </span>
            </div>
            <div className="h-2 sm:h-2.5 rounded-full bg-background-200 overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-500"
                style={{ width: `${width}%`, backgroundColor: item.color }}
              ></div>
            </div>
          </div>
        );
      })}
    </div>
  );
}